export const NumberFormatter = (numberString: string, fraction?: number) => {
  const number = Number(numberString);
  const formattedNumber = number.toLocaleString('en-US', {
    minimumFractionDigits: fraction || 2,
    maximumFractionDigits: fraction || 2,
  });
  return formattedNumber;
};